import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ThemeProvider } from '@/providers/theme-provider'
import { router } from '@/routes'
import { ApiConfigProvider } from './hooks/useApi'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5000,
      refetchOnWindowFocus: true,
    },
  },
})

export function App() {
  return (
		<ApiConfigProvider>
			<QueryClientProvider client={queryClient}>
				<ThemeProvider defaultTheme="dark" storageKey="sui-explorer-theme">
					<RouterProvider router={router} />
				</ThemeProvider>
			</QueryClientProvider>
		</ApiConfigProvider>
  )
}
